module.exports = __webpack_public_path__ + "db9099774e4dac4a14eb5f6055faaae5.svg";